import axios, { AxiosResponse } from 'axios';

export interface IBenefitApi {
    createOrder(step: any): Promise<AxiosResponse<any>>;
    createBenefit(params: any, orderId: string): Promise<AxiosResponse<any>>;
    updateBenefit(benefitId: string, step: any): Promise<AxiosResponse<any>>;
    getProvideServicePoints(benefitId: string, depositMode: string, zipCode: string): Promise<AxiosResponse<any>>;
    getProvideServicePointsByGeographicalCoordinates(benefitId: string, depositMode: any, latitude: any, longitude: any): Promise<AxiosResponse<any>>;
    validateBenefit(benefitId: string): Promise<AxiosResponse<any>>;
    generateTransportVoucher(contactBonTransport): Promise<AxiosResponse<any>>;
    updateBenefitAdresse(benefitId: string, zipCode: string): Promise<AxiosResponse<any>>;
    updateBenefitwhithPrincipalAdresse(benefitId: string , subscriberNumber: string, data: any): Promise<AxiosResponse<any>>;
    searchUseCase(params: any): Promise<AxiosResponse<any>>;
}

class BenefitApi implements IBenefitApi {
    async createOrder(params: any): Promise<AxiosResponse<any>> {
        return await axios.post('/api/benefit/order', params);
    }
    async createBenefit(params: any, orderId: string): Promise<AxiosResponse<any>> {
        return await axios.post(`/api/benefit/order/${orderId}/benefit-transmit`, params);
    }

    async getBenefit(benefitId: string): Promise<AxiosResponse<any>> {
        return await axios.get(`/api/benefit/${benefitId}`);
    }
    async updateBenefit(benefitId: string, params: any): Promise<AxiosResponse<any>> {
        return await axios.put(`/api/benefit/${benefitId}`, params);
    }
    async cancelBenefit(benefitId: string): Promise<AxiosResponse<any>> {
        return await axios.post(`/api/benefit/${benefitId}/cancel`);
    }
    async getProvideServicePoints(benefitId: string, depositMode: string, zipCode: string): Promise<AxiosResponse<any>> {
        return await axios.get(`/api/benefit/${benefitId}/provide-service-points-by-zipCode`, { params: { depositMode, zipCode } });
    }
    async getProvideServicePointsByGeographicalCoordinates(benefitId: string, depositMode: any, latitude: any, longitude: any): Promise<AxiosResponse<any>> {
        return await axios.get(`/api/benefit/${benefitId}/provide-service-points`, { params: { depositMode, latitude, longitude } });
    }
    async validateBenefit(benefitId: string): Promise<AxiosResponse<any>> {
        return await axios.post(`/api/benefit/${benefitId}/validate`);
    }

    async generateTransportVoucher(contactBonTransport: any): Promise<AxiosResponse<any>> {
        return await axios.post('/api/benefit/transport-voucher', contactBonTransport);
    }

    async updateBenefitAdresse(benefitId: string, zipCode: string): Promise<AxiosResponse<any>> {
        return await axios.post(`/api/benefit/${benefitId}/update-benefit-adresse/${zipCode}`);
    }

    async searchUseCase(params: any): Promise<AxiosResponse<any>> {
        return await axios.post(`/api/benefit/search/use-cases`, params);
    }

    async updateBenefitwhithPrincipalAdresse(benefitId: string,subscriberNumber: string, data: any 
        
    ): Promise<AxiosResponse<any>> {
        return await axios.put(`/api/benefit/${benefitId}/update-benefit-whith-principal-adresse/${subscriberNumber}` , data);
    }

    async createBenefitAddress(data: any, benefitId: string): Promise<AxiosResponse<any>> {
        return await axios.post(`/api/benefit/${benefitId}/create-benefit-address`, data);
    }
}


const benefitApi = new BenefitApi();

export { benefitApi };

